import { Observable } from 'rxjs/Observable';
import { LoginForm } from '@ui/types';
import ajax from '@ui/services/api/ajax';

export interface AuthApi {
  checkLoggedIn: (token: string) => Observable<any>;
  login: (loginForm: LoginForm) => Observable<any>;
  logout: (token: string) => Observable<any>;
}

export const authApi: AuthApi = {
  checkLoggedIn: token =>
    ajax.get({ url: 'auth/check-user', params: { token } }),

  login: (loginForm: LoginForm) => {
    const { login, password } = loginForm;

    return ajax.post({ url: 'auth/login', body: { login, password } });
  },

  logout: token => {
    return ajax.get({ url: 'auth/logout', params: { token } });
  },
};



// WEBPACK FOOTER //
// ./src/api/auth/auth.ts